export default {
  objects: {},
  serialized: '',
  objectTypes: [],
  combineFunctions: [],
  adjustmentFunctions: [],
  groups: [],
  boards: []
};